module.exports = __webpack_public_path__ + "img/icon.2eecd010.png";